// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__91mEP","wrapper":"Tab_wrapper__7-jcB","selected":"Tab_selected__pwZnA"};